module.exports = __webpack_public_path__ + "assets/img/new.4592c362.svg";